// Core
import { FaLock } from 'react-icons/fa';
import { MdToken } from 'react-icons/md';

// Chakra
import {
  Box,
  Button,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
} from '@chakra-ui/react';

const AttentionSaleModal = ({
  isOpen,
  onOpen,
  onClose,
  tokens,
  price,
  handleBuy,
  type,
}) => {
  const currentTokens = parseInt(tokens || 0, 10);
  const currentPrice = parseInt(price || 0, 10);

  const canBuy = currentTokens >= currentPrice;

  const missingTokens = Math.max(
    0,
    currentPrice - currentTokens
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
    >
      <ModalOverlay
        bg="rgba(0,0,0,0.72)"
        backdropFilter="blur(5px)"
      />

      <ModalContent
        className="modal__simple modal__attention"
        maxW="100%"
        mx="14px"
        overflow="hidden !important"
        overflowX="hidden"
        position="relative"
        borderRadius="20px"
      >
        <ModalCloseButton
          zIndex="20"
          color="rgba(255,255,255,0.55)"
        />

        {/* Neon glow */}
        <Box
          position="absolute"
          top="-80px"
          left="-60px"
          w="180px"
          h="180px"
          bg={
            canBuy
              ? 'rgba(195,68,255,0.11)'
              : 'rgba(255,49,87,0.10)'
          }
          filter="blur(60px)"
          pointerEvents="none"
        />

        <Box
          position="absolute"
          bottom="-90px"
          right="-60px"
          w="180px"
          h="180px"
          bg="rgba(67,247,255,0.07)"
          filter="blur(65px)"
          pointerEvents="none"
        />

        <ModalHeader
          px="20px"
          pt="20px"
          pb="14px"
          position="relative"
          bg="rgba(0,0,0,0.16)"
          borderBottom="1px solid rgba(255,255,255,0.04)"
        >
          <Text
            fontSize="19px"
            fontWeight="900"
            letterSpacing="0.3px"
            color="rgba(255,255,255,0.84)"
          >
            {canBuy
              ? 'Unlock Item'
              : 'Not Enough Tokens'}
          </Text>

          <Flex
            align="center"
            gap="7px"
            mt="4px"
            mb="16px"
          >
            <Box
              w="6px"
              h="6px"
              borderRadius="50%"
              bg={
                canBuy
                  ? '#C344FF'
                  : '#FF3157'
              }
              boxShadow={
                canBuy
                  ? '0 0 7px #C344FF'
                  : '0 0 7px #FF3157'
              }
            />

            <Text
              fontSize="10px"
              color="rgba(255,255,255,0.34)"
              fontWeight="700"
              textTransform="uppercase"
              letterSpacing="0.7px"
            >
              Garage purchase
            </Text>
          </Flex>
        </ModalHeader>

        <ModalBody
          px="14px"
          pt="16px"
          pb="16px"
          overflowX="hidden"
        >
          <Box
            position="relative"
            borderRadius="18px"
            p="18px"
            mt="16px"
            bg={
              canBuy
                ? 'linear-gradient(135deg, rgba(195,68,255,0.07), rgba(67,247,255,0.035))'
                : 'linear-gradient(135deg, rgba(255,49,87,0.07), rgba(255,255,255,0.02))'
            }
            border={
              canBuy
                ? '1px solid rgba(195,68,255,0.16)'
                : '1px solid rgba(255,49,87,0.16)'
            }
            overflow="hidden"
          >
            {/* Lock */}
            <Flex
              mx="auto"
              mb="16px"
              align="center"
              justify="center"
              w="64px"
              h="64px"
              borderRadius="18px"
              bg={
                canBuy
                  ? 'rgba(195,68,255,0.08)'
                  : 'rgba(255,49,87,0.08)'
              }
              border={
                canBuy
                  ? '1px solid rgba(195,68,255,0.25)'
                  : '1px solid rgba(255,49,87,0.25)'
              }
              boxShadow={
                canBuy
                  ? '0 0 20px rgba(195,68,255,0.10)'
                  : '0 0 20px rgba(255,49,87,0.10)'
              }
            >
              <FaLock
                size={23}
                color={
                  canBuy
                    ? '#C344FF'
                    : '#FF3157'
                }
              />
            </Flex>

            {canBuy ? (
              <>
                <Text
                  textAlign="center"
                  fontSize="13px"
                  lineHeight="19px"
                  color="rgba(255,255,255,0.58)"
                >
                  Unlock this{' '}
                  <Text
                    as="span"
                    fontWeight="900"
                    color="#FFFFFF"
                  >
                    {type}
                  </Text>{' '}
                  for:
                </Text>

                <Flex
                  mt="12px"
                  justify="center"
                  align="center"
                  gap="7px"
                >
                  <MdToken
                    size={28}
                    color="#FF496A"
                    style={{
                      filter:
                        'drop-shadow(0 0 7px rgba(255,49,87,0.55))',
                    }}
                  />

                  <Text
                    fontSize="27px"
                    lineHeight="1"
                    fontWeight="950"
                    color="#FFFFFF"
                  >
                    {currentPrice}
                  </Text>
                </Flex>

                <Text
                  mt="8px"
                  textAlign="center"
                  fontSize="9px"
                  color="rgba(255,255,255,0.28)"
                  textTransform="uppercase"
                  letterSpacing="0.6px"
                >
                  This action cannot be undone
                </Text>

                <Button
                  mt="20px"
                  w="100%"
                  h="46px"
                  borderRadius="13px"
                  bg="rgba(195,68,255,0.14)"
                  border="1px solid rgba(195,68,255,0.42)"
                  color="#D993FF"
                  boxShadow="0 0 16px rgba(195,68,255,0.08)"
                  _hover={{
                    bg:
                      'rgba(195,68,255,0.22)',
                  }}
                  onClick={handleBuy}
                >
                  <Text
                    fontSize="12px"
                    fontWeight="900"
                    textTransform="uppercase"
                    letterSpacing="0.8px"
                  >
                    Confirm Unlock
                  </Text>
                </Button>

                <Button
                  mt="8px"
                  w="100%"
                  h="40px"
                  borderRadius="12px"
                  variant="ghost"
                  bg="rgba(255,255,255,0.025)"
                  border="1px solid rgba(255,255,255,0.055)"
                  color="rgba(255,255,255,0.45)"
                  _hover={{
                    bg:
                      'rgba(255,255,255,0.06)',
                    color: '#FFFFFF',
                  }}
                  onClick={onClose}
                >
                  <Text
                    fontSize="10px"
                    fontWeight="800"
                    textTransform="uppercase"
                    letterSpacing="0.7px"
                  >
                    Cancel
                  </Text>
                </Button>
              </>
            ) : (
              <>
                <Text
                  textAlign="center"
                  fontSize="13px"
                  lineHeight="19px"
                  color="rgba(255,255,255,0.58)"
                >
                  You need
                </Text>

                <Flex
                  mt="10px"
                  justify="center"
                  align="center"
                  gap="7px"
                >
                  <MdToken
                    size={27}
                    color="#FF496A"
                  />

                  <Text
                    fontSize="26px"
                    fontWeight="950"
                    color="#FFFFFF"
                  >
                    {currentPrice}
                  </Text>
                </Flex>

                <Text
                  mt="9px"
                  textAlign="center"
                  fontSize="11px"
                  color="rgba(255,255,255,0.38)"
                >
                  You currently have{' '}
                  <Text
                    as="span"
                    color="#FF6B85"
                    fontWeight="900"
                  >
                    {currentTokens}
                  </Text>{' '}
                  tokens.
                </Text>

                <Flex
                  mt="14px"
                  justify="center"
                  align="center"
                  gap="5px"
                  px="10px"
                  py="7px"
                  borderRadius="10px"
                  bg="rgba(255,49,87,0.06)"
                  border="1px solid rgba(255,49,87,0.12)"
                >
                  <Text
                    fontSize="9px"
                    fontWeight="800"
                    color="rgba(255,255,255,0.35)"
                    textTransform="uppercase"
                    letterSpacing="0.5px"
                  >
                    Missing
                  </Text>

                  <MdToken
                    size={13}
                    color="#FF496A"
                  />

                  <Text
                    fontSize="11px"
                    fontWeight="900"
                    color="#FF6680"
                  >
                    {missingTokens}
                  </Text>
                </Flex>

                <Button
                  mt="18px"
                  w="100%"
                  h="42px"
                  borderRadius="12px"
                  variant="ghost"
                  bg="rgba(255,255,255,0.025)"
                  border="1px solid rgba(255,255,255,0.06)"
                  color="rgba(255,255,255,0.58)"
                  _hover={{
                    bg:
                      'rgba(255,255,255,0.06)',
                    color: '#FFFFFF',
                  }}
                  onClick={onClose}
                >
                  <Text
                    fontSize="11px"
                    fontWeight="900"
                    textTransform="uppercase"
                    letterSpacing="0.7px"
                  >
                    Back
                  </Text>
                </Button>
              </>
            )}
          </Box>

          {/* Balance */}
          <Flex
            mt="10px"
            px="5px"
            justify="center"
            align="center"
            gap="5px"
          >
            <Text
              fontSize="9px"
              color="rgba(255,255,255,0.24)"
              textTransform="uppercase"
              letterSpacing="0.6px"
            >
              Your balance
            </Text>

            <MdToken
              size={13}
              color="#FF496A"
            />

            <Text
              fontSize="10px"
              fontWeight="900"
              color="rgba(255,255,255,0.48)"
            >
              {currentTokens}
            </Text>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AttentionSaleModal;